import React, { Component } from "react";
import moment from "moment";
import SimpleReactLightbox from "simple-react-lightbox";
import LeftSideNavigation from "../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminComponents/superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { ViewOpenIssuesTicketRight } from "../../superAdminComponents/superAdminAllComponent/superAdminOpenIssuesUsers/ViewUsersTickets/ViewOpenIssuesTicketRight";
import { ViewOpenIssuesTicketLeft } from "../../superAdminComponents/superAdminAllComponent/superAdminOpenIssuesUsers/ViewUsersTickets/ViewOpenIssuesTicketLeft";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../store/actions/errorActions";
import {
  comment_vendor_users_tickets,
  get_vendor_users_tickets,
} from "../../../store/actions/VendorUsersTicketsActions/vendorUsersTicketsActions";
import isEmpty from "../../../store/validation/is-Empty";
import store from "../../../store/store";
import { EDIT_VENDOR_USER_TICKETS_DETAILS } from "../../../store/types";

export class VendorOpenIssuesTicketEdit extends Component {
  constructor(props) {
    super();
    this.state = {
      allViewData: {},
      detailsProps: {},
      dinerInfo: {},
      dinerInfoUserDetails: {},
      userInfo: {},
      refrenceImages: [],
      comment: [],
      contactDetails: "",
      enquiryEmails: "",
      displayChatScreen: false,
      onComment: "",
      hasSetDetails: false,
      flag: false,
    };
  }

  componentDidMount() {
    this.props.get_vendor_users_tickets(this.props.auth.user.accessToken);
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (nextProps.editUserTicket !== nextState.allViewData) {
      return {
        allViewData: !isEmpty(nextProps.editUserTicket)
          ? nextProps.editUserTicket
          : [],
        detailsProps: !isEmpty(nextProps.editUserTicket.restaurant_id)
          ? nextProps.editUserTicket.restaurant_id
          : [],
        dinerInfo: !isEmpty(nextProps.editUserTicket.diner_id)
          ? nextProps.editUserTicket.diner_id
          : [],
        dinerInfoUserDetails: !isEmpty(
          nextProps.editUserTicket.diner_id.user_details
        )
          ? nextProps.editUserTicket.diner_id.user_details
          : [],
        userInfo: !isEmpty(nextProps.editUserTicket.user_id)
          ? nextProps.editUserTicket.user_id
          : [],
        refrenceImages: !isEmpty(nextProps.editUserTicket.refrence_images)
          ? nextProps.editUserTicket.refrence_images
          : [],
        comment: !isEmpty(nextProps.editUserTicket.comment)
          ? nextProps.editUserTicket.comment
          : [],
        contactDetails: !isEmpty(
          nextProps.editUserTicket.restaurant_id.contact_detail
        )
          ? nextProps.editUserTicket.restaurant_id.contact_detail[0]
          : "",
        enquiryEmails: !isEmpty(
          nextProps.editUserTicket.restaurant_id.enquiry_email
        )
          ? nextProps.editUserTicket.restaurant_id.enquiry_email[0]
          : "",
        hasSetDetails: true,
      };
    } else {
      return null;
    }
  }

  componentDidUpdate() {
    let oldData = this.props.editUserTicket;
    let newUpdateData = this.props.allUsersTicketsDetails;
    let singleData = newUpdateData.find((data) => data._id === oldData._id);
    store.dispatch({
      type: EDIT_VENDOR_USER_TICKETS_DETAILS,
      payload: singleData,
    });
  }

  onHandleComment = (e) => {
    this.setState({
      onComment: e.target.value,
    });
  };

  handleCommentSubmit = (e) => {
    const token = this.props.auth.user.accessToken;
    let ticketId = this.state.allViewData._id;
    const formData = {
      comment: this.state.onComment,
    };
    this.props.comment_vendor_users_tickets(formData, token, ticketId);
    this.setState({
      flag: true,
      onComment: "",
    });
    // this.props.history.push("/vendoruseropenissues");
  };

  onChangeScreenChat = (e) => {
    this.setState({
      displayChatScreen: !this.state.displayChatScreen,
    });
  };

  renderResolutionLogBody = () => {
    const { allViewData } = this.state;
    if (!isEmpty(allViewData)) {
      return allViewData.ticketLogs.map((data, index) => (
        <React.Fragment key={index}>
          <tr>
            <td>
              <div>
                <h4>{moment(data.time).format("Do MMM YYYY")}</h4>
                <h4>{moment(data.time).format("hh:mm A")}</h4>
              </div>
            </td>
            <td>{data.content}</td>
            <td>{data.initiator}</td>
          </tr>
        </React.Fragment>
      ));
    } else {
      return null;
    }
  };

  render() {
    const {
      allViewData,
      detailsProps,
      dinerInfo,
      dinerInfoUserDetails,
      userInfo,
      refrenceImages,
      comment,
      contactDetails,
      enquiryEmails,
    } = this.state;
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation
                displayText={`Ticket No: ${allViewData.ticket_number}`}
                displayBack={true}
                backButtonLink="/vendoruseropenissues"
              />
              <div className="super-admin-inside-right-side-panel pt-4 pb-4">
                <div className="row">
                  <div className="col-5">
                    <SimpleReactLightbox>
                      <ViewOpenIssuesTicketLeft
                        sendDataProps={allViewData}
                        detailsProps={detailsProps}
                        dinerInfoUserDetails={dinerInfoUserDetails}
                        dinerInfo={dinerInfo}
                        userInfo={userInfo}
                        refrenceImages={refrenceImages}
                        comment={comment}
                        contactDetails={contactDetails}
                        enquiryEmails={enquiryEmails}
                      />
                    </SimpleReactLightbox>
                  </div>
                  <div className="col-7">
                    <ViewOpenIssuesTicketRight
                      dinerInfo={dinerInfo}
                      dinerInfoUserDetails={dinerInfoUserDetails}
                      sendDataProps={allViewData}
                      displayEdit={true}
                      tableBody={this.renderResolutionLogBody()}
                      displayInput={true}
                      displayChatScreen={this.state.displayChatScreen}
                      displayChatScreenFunc={this.onChangeScreenChat}
                      onChange={this.onHandleComment}
                      onComment="onComment"
                      commentValue={this.state.onComment}
                      onClickChatButton={this.handleCommentSubmit}
                      comment={comment}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

VendorOpenIssuesTicketEdit.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  editUserTicket: state.vendorUsersTickets.edit_vendor_user_tickets,
  allUsersTicketsDetails: state.vendorUsersTickets.vendor_all_users_tickets,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  comment_vendor_users_tickets,
  get_vendor_users_tickets,
})(withRouter(VendorOpenIssuesTicketEdit));
